<template>
  <div class="total-data-wrapper">
    <div class="list-item" v-for="(item, index) in dataList" :key="index">
      <h2 class="title">{{ item.year }}年月度运营报告</h2>
      <div class="month-data-list clearfix">
        <a
          :href="
            `https://jinrfe.jinr.com/JydReport/index.html#/report?years=${item.year}&month=${
              month.month < 10 ? `0${month.month}` : month.month
            }`
          "
          v-for="(month, index) in item.list"
          :key="`${item.year}-${index}`"
          class="data-item"
        >
          <img src="https://files.jinr.com/jinr-index/img/data-report.png" alt="" srcset="" />
          <p class="year">{{ item.year }}</p>
          <p class="month">第{{ month.month }}月份</p>
          <p class="text">运营报告</p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import dataList from './map.js';
export default {
  name: 'total-data',
  computed: {
    dataList() {
      return dataList;
    }
  }
};
</script>
<style lang="less" scoped>
.total-data-wrapper {
  .title {
    text-align: center;
    font-size: 30px;
    padding: 40px 0;
    color: #666;
  }
  .data-item {
    position: relative;
    float: left;
    width: 308px;
    height: 134px;
    margin: 2px;
    color: #fff;
    img {
      width: 100%;
    }
    .year {
      position: absolute;
      top: 46px;
      left: 66px;
      font-size: 26px;
      font-weight: 600;
    }
    .month {
      position: absolute;
      top: 82px;
      left: 62px;
      padding: 0px 10px;
      background: #fff;
      color: #247af1;
      border-radius: 10px;
      font-size: 12px;
    }
    .text {
      position: absolute;
      top: 40px;
      right: 20px;
      font-size: 30px;
    }
  }
}
</style>
